import { render, staticRenderFns } from "./wl-footer.vue?vue&type=template&id=2d0d301e&scoped=true&"
import script from "./wl-footer.vue?vue&type=script&lang=js&"
export * from "./wl-footer.vue?vue&type=script&lang=js&"
import style0 from "./wl-footer.vue?vue&type=style&index=0&id=2d0d301e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0d301e",
  null
  
)

export default component.exports